import { createActions, createReducer } from 'reduxsauce'

import ConsultaProvimentosServidoresService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaProvimentosServidoresInicio: [],
    buscaConsultaProvimentosServidoresErro: ['erro'],
    buscaConsultaProvimentosServidoresSucesso: ['consultaProvimentosServidores'],
    limpar: [],
    setConsultaProvimentosServidoresEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaProvimentosServidores = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaProvimentosServidoresInicio())
        let serv = new ConsultaProvimentosServidoresService()
        return serv
            .consultarProvimentos(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaProvimentosServidoresSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaProvimentosServidoresErro(error)))
    }
}

const buscaConsultaProvimentosServidoresInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaProvimentosServidoresErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaProvimentosServidoresSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaProvimentosServidores.resultado,
        dataSincronizacaoDados: action.consultaProvimentosServidores.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaProvimentosServidores.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaProvimentosServidoresEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PROVIMENTOS_SERVIDORES_INICIO]: buscaConsultaProvimentosServidoresInicio,
    [Types.BUSCA_CONSULTA_PROVIMENTOS_SERVIDORES_ERRO]: buscaConsultaProvimentosServidoresErro,
    [Types.BUSCA_CONSULTA_PROVIMENTOS_SERVIDORES_SUCESSO]: buscaConsultaProvimentosServidoresSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PROVIMENTOS_SERVIDORES_ESTADO_DT]: setConsultaProvimentosServidoresEstadoDT,
})
